import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "flex items-start justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "flex items-center justify-center gap-6 mx-auto mt-3 text-center sm:mt-5" }
const _hoisted_4 = { class: "mt-2 text-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "mt-2 text-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "mt-2 text-center" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "mt-2 text-center" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "flex items-center justify-center w-full mt-6 space-x-3 text-center" }
const _hoisted_13 = { class: "mt-4 text-sm leading-6 text-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "mt-5 sm:mt-6" }

import {inject, ref} from 'vue';
import {ShareIcon} from '@heroicons/vue/24/outline';
import {useClipboard} from '@vueuse/core';
import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import QrCode from "@/main/components/QrCode.vue";
import {trackEvent} from '@/shared';


export default /*@__PURE__*/_defineComponent({
  __name: 'SaSocialShare',
  props: {
    url: {
        type: String,
        default: window.location.href
    },
    title: {
        type: String,
        default: ''
    }
},
  setup(__props) {

// @ts-ignore
const props = __props

const url: string = props.url;
const title: string = props.title;

const {text, copy, copied, isSupported} = useClipboard();

const isOpen = ref(false);

const openShareModal = async () => {
    isOpen.value = true;
}

const closeShareModal = async () => {
    isOpen.value = false;
}

const clickedToShare = async (method : string) => {
    trackEvent( 'share', {
        link_url: url,
        link_text: title,
        method: method,
    });
}

const copyAndTrack = async (url : string) => {
    await copy(url);
    await clickedToShare('copy_link')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { openShareModal: openShareModal }, () => [
      _createElementVNode("button", {
        class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
        type: "button",
        "aria-label": "Open Social Share",
        onClick: openShareModal
      }, [
        _createVNode(_unref(ShareIcon), { class: "w-5 h-5 text-lg" })
      ])
    ]),
    _createVNode(_unref(TransitionRoot), {
      show: isOpen.value,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: closeShareModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform border-2 rounded-lg shadow-xl bg-powder-50 sm:my-8 sm:max-w-lg sm:w-full sm:p-6 border-powder-500" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("p", {
                            class: "mt-3 text-xl font-medium leading-6 text-center uppercase text-powder-900",
                            id: "modal-title"
                          }, " Share: ", -1)),
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (clickedToShare('facebook'))),
                                href: `https://www.facebook.com/sharer.php?u=${_unref(url)}`,
                                target: "_blank",
                                alt: "Share to facebook",
                                title: "Share to facebook"
                              }, _cache[6] || (_cache[6] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "1em",
                                  viewBox: "0 0 512 512",
                                  class: "inline-block w-8 h-8 mr-2 md:h-10 md:w-10 text-fb hover:shadow-sm",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("path", { d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" })
                                ], -1)
                              ]), 8, _hoisted_5)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (clickedToShare('x'))),
                                href: `https://x.com/intent/tweet?url=${_unref(url)}`,
                                target: "_blank",
                                alt: "Share on X",
                                title: "Share on X"
                              }, _cache[7] || (_cache[7] = [
                                _createElementVNode("svg", {
                                  class: "inline-block w-8 h-8 mr-2 text-black md:h-10 md:w-10 hover:shadow-sm",
                                  fill: "currentColor",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "1em",
                                  viewBox: "0 0 512 512"
                                }, [
                                  _createElementVNode("path", { d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" })
                                ], -1)
                              ]), 8, _hoisted_7)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("a", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (clickedToShare('linkedin'))),
                                href: `https://www.linkedin.com/sharing/share-offsite/?url=${_unref(url)}`,
                                title: "Share on LinkedIn",
                                alt: "Share on LinkedIn",
                                target: "_blank"
                              }, _cache[8] || (_cache[8] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "inline-block w-8 h-8 mr-2 md:h-10 md:w-10 text-linkedin hover:shadow-sm",
                                  fill: "currentColor",
                                  viewBox: "0 0 448 512"
                                }, [
                                  _createElementVNode("path", { d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" })
                                ], -1)
                              ]), 8, _hoisted_9)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("a", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (clickedToShare('email'))),
                                class: "text-gray-600 hover:text-gray-600",
                                href: `mailto:?subject=${_unref(title)}&body=I found this article on StageAgent and thought you might find it helpful. ${_unref(url)}`,
                                title: "Share by Email",
                                alt: "Share by Email"
                              }, _cache[9] || (_cache[9] = [
                                _createElementVNode("svg", {
                                  class: "inline-block w-8 h-8 mr-2 md:h-10 md:w-10 text-inherit hover:shadow-sm",
                                  fill: "currentColor",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "1em",
                                  viewBox: "0 0 512 512"
                                }, [
                                  _createElementVNode("path", { d: "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" })
                                ], -1)
                              ]), 8, _hoisted_11)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "inline-block text-sm uppercase" }, "or get QR here: ", -1)),
                            _createVNode(QrCode, {
                              url: _unref(url),
                              title: _unref(title)
                            }, null, 8, ["url", "title"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("p", null, [
                            _createElementVNode("button", {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (copyAndTrack(_unref(url)))),
                              class: "font-semibold text-powder-800 hover:text-powder-900"
                            }, [
                              (!_unref(copied))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                    _cache[12] || (_cache[12] = _createElementVNode("svg", {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      class: "inline-block w-5 h-5 mr-2 text-inherit hover:shadow-sm",
                                      fill: "currentColor",
                                      viewBox: "0 0 640 512"
                                    }, [
                                      _createElementVNode("path", { d: "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z" })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(url)), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_15, "Copied!"))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            "aria-label": "Close",
                            onClick: _withModifiers(closeShareModal, ["prevent"]),
                            type: "button",
                            class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-powder-900 hover:bg-powder-800 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-zinc-500 sm:text-sm"
                          }, " Close ")
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})